// Constants
import Constants from 'constants.js';
// Dispatcher
import Dispatcher from 'core/Dispatcher';
// Facade
import Facade from 'core/Facade';
// Action
import CatalogService from 'services/CatalogService';
// Actions
import AlertAction from 'actions/AlertAction';
// Locales
import translate from 'locales/i18n';

class CatalogAction {
    getCatalogs(params) {
        Dispatcher.dispatch({
            actionType: Constants.CATALOGS_GET_START,
            value: params
        });

        CatalogService.getCatalogs(params).then(response => {
            const data = Facade.keysToCamel(response);
            data.params = params;
            Dispatcher.dispatch({
                actionType: Constants.CATALOGS_GET_END,
                value: data
            });
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    getCatalog(id) {
        return CatalogService.getCatalog(id).then(data => Facade.keysToCamel(data),
            response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }
}

export default new CatalogAction();
